export default __webpack_public_path__ + "static/media/h2-img-1.cbebfa49.png";